import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import { useEventTracking } from 'hooks/useEventTracking';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'router/routes';

interface TotalProps {
  totalAmount: number;
  currency: string;
  eventId: number;
  ticketQuantity: number;
  isDisabled?: boolean;
  isFreeEvent?: boolean;
}

export const Total = ({
  totalAmount,
  currency,
  eventId,
  ticketQuantity,
  isDisabled,
  isFreeEvent,
}: TotalProps) => {
  const navigate = useNavigate();
  const { eventTracking } = useEventTracking();

  const handleGoToCheckout = () => {
    eventTracking.cart.addToCart({
      eventId,
      ticketQuantity,
      totalPrice: totalAmount,
    });
    navigate('/' + ROUTES.checkout);
  };

  return (
    <VStack
      spacing='16px'
      align='stretch'
      bg='white'
      p='16px 24px'
      boxShadow='0px 0px 50px rgba(167, 167, 167, 0.16)'
      justifySelf='end'
      position='sticky'
      bottom={0}
    >
      <HStack justify='space-between' align='center'>
        <Text variant='bodyLargestRegular' color={isFreeEvent ? 'teal.500' : undefined}>
          {isFreeEvent ? (
            <FormattedMessage id='freeEvent.label' defaultMessage='Free' />
          ) : (
            `${currency} ${new Intl.NumberFormat().format(totalAmount)}`
          )}
        </Text>
        <Text variant='bodyLargestRegular'>
          <FormattedMessage id='eventpage.total.total' defaultMessage='Total' />
        </Text>
      </HStack>
      <Button onClick={handleGoToCheckout} variant='primaryLarge' isDisabled={isDisabled}>
        {isFreeEvent ? (
          <FormattedMessage
            id='eventpage.total.gotocheckoutFree'
            defaultMessage='Continue to reserve'
          />
        ) : (
          <FormattedMessage id='eventpage.total.gotocheckout' defaultMessage='Go to checkout' />
        )}
      </Button>
    </VStack>
  );
};
